import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllVoucherApi } from "@/api/voucher";
import { deleteVoucherHistoryApi, getAllVoucherHistoryApi } from "@/api/voucherHistory";

// Thunks
export const fetchVoucherHistories = createAsyncThunk(
  "voucherHistory/fetchVoucherHistories",
  async (
    { restaurant_id, page = 1, search = "", status = "", per_page = 10 },
    { rejectWithValue }
  ) => {
    const params = new URLSearchParams();

    params.append("per_page", per_page);
    params.append("page", page);

    if (search) {
      params.append("search_term", search);
    }

    if (status) {
      params.append("status", status);
    }

    const res = await getAllVoucherHistoryApi(restaurant_id, params.toString());

    if (res.status === "success") {
      return { ...res.data, search };
    }

    return rejectWithValue(res.message);
  }
);

export const deleteVoucherHistoryById = createAsyncThunk(
  "voucher/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteVoucherHistoryApi(id);
    if (res.status === "success") return id;
    return rejectWithValue(res.message);
  }
);

// Initial State
const initialState = {
  voucherHistories: [],
  singleVoucherHistoryCard: null,
  totalVoucherHistoryPages: 1,

  getVoucherHistoryLoading: false,
  createVoucherHistoryLoading: false,
  updateVoucherHistoryLoading: false,
  deleteVoucherHistoryLoading: false,

  success: null,
  error: null,
  requestStatus: false,
  searchVoucherHistory: "",
  voucherHistoryStatus: "",
  voucherHistoryPerPage: 10,
  voucherHistoryCurrentPage: 1
};

// Slice
const voucherHistorySlice = createSlice({
  name: "voucherHistories",
  initialState,
  reducers: {
    clearVoucherHistoryMessages: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
      state.totalVoucherHistoryPages = 1;
      state.searchVoucherHistory = "";
    },
    setVoucherHistorySearch: (state, action) => {
      state.searchVoucherHistory = action.payload;
    },
    setVoucherHistoryStatus: (state, action) => {
      state.voucherHistoryStatus = action.payload;
    },
    setVoucherHistoryPerPage: (state, action) => {
      state.voucherHistoryPerPage = action.payload;
    },
    setVoucherHistoryCurrentPage: (state, action) => {
      state.voucherHistoryCurrentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      // Fetch All
      .addCase(fetchVoucherHistories.pending, (state) => {
        state.getVoucherHistoryLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchVoucherHistories.fulfilled, (state, action) => {
        state.getVoucherHistoryLoading = false;        
        state.voucherHistories = action.payload.voucher_histories;
        state.requestStatus = true;
        state.totalVoucherHistoryPages = action.payload.pagination.last_page;
      })
      .addCase(fetchVoucherHistories.rejected, (state, action) => {
        state.getVoucherHistoryLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })
      // Delete
      .addCase(deleteVoucherHistoryById.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(deleteVoucherHistoryById.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.voucherHistories = state.voucherHistories.filter(
          (voucher) => voucher.id !== action.payload
        );
        state.success = "Voucher history deleted successfully!";
        state.requestStatus = true;
      })
      .addCase(deleteVoucherHistoryById.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      });
  },
});

export const { clearVoucherHistoryMessages, setVoucherHistorySearch, setVoucherHistoryCurrentPage, setVoucherHistoryPerPage, setVoucherHistoryStatus } = voucherHistorySlice.actions;
export default voucherHistorySlice.reducer;
